var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"512","height":"512","rx":"15%","key":0}),React.createElement("path",{"d":"m427 169c-4-15-17-27-32-31-34-9-239-10-278 0-15 4-28 16-32 31-9 38-10 135 0 174 4 15 17 27 32 31 36 10 241 10 278 0 15-4 28-16 32-31 9-36 9-137 0-174","fill":"#fff","key":1}),React.createElement("path",{"d":"m220 203v106l93-53","key":2})]);
}

Youtube.defaultProps = {"aria-label":"YouTube","role":"img","viewBox":"0 0 512 512","fill":"#ed1d24"};

module.exports = Youtube;

Youtube.default = Youtube;
